/**
 * Application, contract application and card shared status.
 */
export enum ItemStatus {

    /**
     * Item is being added.
     */
    NEW = 'NEW',

    /**
     * Item is enabled.
     */
    ENABLED = 'ENABLED'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/enums/item-status.enum.ts